import type { ILanguageResources, ITranslationModule } from '../../../../interfaces';
import { interpolate } from '../../../../global';

class Id {
  private constructor() {}
  public static readonly prefix = 'UI.scripts.dealer-franchisee.dashboard.widget.BranchMonthlyRevenuePipeline.';
  public static readonly monthlyRevenuePipeline = `${Id.prefix}monthlyRevenuePipeline`;
}

export class LangDashboardBranchMonthlyRevenuePipeline {
  private constructor() {}
  public static monthlyRevenuePipeline(): string {
    return interpolate(Id.monthlyRevenuePipeline);
  }
}

export class DashboardBranchMonthlyRevenuePipelineModule implements ITranslationModule {
  registerItems(register: ILanguageResources) {
    register.add(Id.monthlyRevenuePipeline, 'Monthly Revenue Pipeline', 'Header for monthly revenue pipeline widget');
  }
}
